<style>
  .pageDisplay {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: space-between;
    gap: 15px;
  }

  .supportBox {
    flex: 1;
    order: 2;
  }
  .mainArea {
    flex: 3;
  }

  @media (max-width: 700px) {
    .pageDisplay {
      flex-direction: column;
    }

    .supportBox {
      order: -1;
    }
  }
</style>

<swipesum-header [appName]="'Portal'"></swipesum-header>


<div
  style="display: flex; justify-content: flex-start; align-items: flex-start"
>
  <div
    class="sticky"
    style="flex: 1; min-width: 200px; width: 200px; max-width: 200px; top: 60px"
  >
    <div style="width: 100%">
      <app-profile-button></app-profile-button>
    </div>
    <div style="width: 100%">
      <app-secondary-nav></app-secondary-nav>
    </div>
  </div>

  <div style="flex: auto; align-content: center">
    <div style="width: 100%; background-color: var(--colorBodyBackground)">
      <div
        style="
          position: fixed;
          top: 0px;
          width: 100%;
          height: 60px;
          background-color: var(--colorCal);
          align-items: center;
          z-index: 9999999;
        "
      >
        <!-- <div style="padding:0px 0px 0px 25px; width:65%;">
            <app-site-search></app-site-search>
          </div> -->
      </div>

      <div style="padding: 25px 25px 0px 25px">
        <app-impersonate-header></app-impersonate-header>

        <div class="pageDisplay">
          <div class="mainArea">
            <router-outlet></router-outlet>
            <!-- <app-launch-chat-button></app-launch-chat-button> -->
          </div>
        </div>

        <swipesum-footer [appName]="'Portal'" class="footer-container"></swipesum-footer>      </div>
    </div>
  </div>
</div>
